export const VARIABLES = {
    MAINTENANCE: process.env.MAINTENANCE_MODE,
    PROMO: false,
    START_STEPS: "START_STEPS"
};
